import { Text, Stack, HStack, Box, Flex } from "@chakra-ui/react";
import { textSecondary, textPrimary } from "../../../../utils/colors";
import StatusButtonNew from "../../../../components/buttons/StatusButtonNew";
import MoreButtonLite from "../../../../components/buttons/MoreButtonLite";

export const columnsMobile = (
  slug,
  dispatch,
  translate,
  updateProfessionGroupStatus,
  handleSortChange,
  setProfessionGroupId,
  setShowDeleteConfirmation,
  setProfessionGroupName,
  setSelectedProfessionCount,
  hasAccessToEdit,
  openEditSidePanelModal
) => {
  return [
    {
      Header: () => (
        <Box onClick={() => handleSortChange("name")}>
          <Flex align="center" cursor="pointer">
            <Text mr={2}>{translate("serviceGroup.columnName")}</Text>
          </Flex>
        </Box>
      ),
      accessor: "name",
      // width: 420,
      disableSortBy: true,
      Cell: ({ row }) => {
        const { name } = row.original;

        return (
          <HStack gap={2}>
            <Stack gap={0}>
              <Text
                fontSize="sm"
                color={textPrimary}
                textAlign="left"
                fontWeight="600"
                isTruncated // This will add ellipsis
                maxWidth="78%"
              >
                {name}
              </Text>
            </Stack>
          </HStack>
        );
      },
    },

    {
      Header: () => (
        <Box onClick={() => handleSortChange("status")} w="100%">
          <Flex align="center" cursor="pointer" justify="flex-end" w="100%">
            <Text mr={2}>{translate("patient.columnStatus")}</Text>
          </Flex>
        </Box>
      ),
      accessor: "status",
      disableSortBy: true,
      preventRowClick: false,
      Cell: ({ row }) => {
        const { status, _id } = row.original;

        // console.log("row", row.original);

        const handleUpdateStatus = (newStatus) => {
          dispatch(updateProfessionGroupStatus(slug, _id, newStatus));
        };

        return (
          <HStack gap={0} justify="flex-end">
            <StatusButtonNew
              currentStatus={status}
              onUpdateStatus={handleUpdateStatus}
              options="serviceNew"
              p="0 2.5rem"
              isUnclickable
            />
          </HStack>
        );
      },
    },
  ];
};
